import React from 'react'
import { useSelector } from '~/store/hooks'

import { Link } from 'gatsby'
import slugify from 'slugify'

import trads from '~/intl/trads.json'

import eventDate from '~/utils/eventDate'
import GetNewsroomUrls from '~/utils/getNewsroomUrls'

const InnerContent = ({ hit, date, color, lang, isFromPortal = false }) => {
  const dateOptions = { year: 'numeric', month: 'short', day: 'numeric' }

  const formatedDate =
    hit.contentType === 'event'
      ? date
      : new Date(date).toLocaleDateString(lang, dateOptions)

  return (
    <>
      {hit.title}
      <div className="md:pl-4 order-first mb-5 md:mb-0 md:order-last justify-between flex items-center flex-shrink-0">
        {date !== null && (
          <span className="text-label block md:mr-8 search-hit__date lg:flex-shrink-0">
            {formatedDate}
          </span>
        )}
        <span
          className={`order-first md:order-last text-label text-label--bg text-label--rounded bg-${color} ${hit.contentType === 'page' || hit.contentType === 'project' ? 'text-purple' : 'text-white'} flex-shrink-0`}
        >
          {trads[lang].lab.contentTypes[hit.contentType]}
        </span>
        {isFromPortal ? (
          <span className="search-hit__mention">Portail client</span>
        ) : (
          ''
        )}
      </div>
    </>
  )
}

const HitOther = ({ hit, setSearchState, emptyResults = false }) => {
  const lang = useSelector((state) => state.lang)
  const newsroomUrls = GetNewsroomUrls()

  let url = null
  let color = null
  let date = null
  let isFromPortal =
    hit.distributionChannel !== undefined
      ? !hit.distributionChannel.includes('Site internet')
      : false

  if (emptyResults) {
    isFromPortal = false
  }

  const isFr = lang === 'fr'
  const slugifiedTitle =
    typeof hit?.title === 'string' &&
    slugify(hit?.title, {
      remove: /[*+~.()'"!?:@,]/g,
    }).toLowerCase()

  switch (hit.contentType) {
    case 'news':
      color = 'blue'
      date = hit.publicationDate
      url = `/${newsroomUrls['Actualités'][lang]}/${slugifiedTitle}`
      break
    case 'event':
      color = 'purple'
      date = eventDate(
        hit.startDate,
        hit.endDate,
        trads[lang].date.from,
        trads[lang].date.to,
        '',
        lang,
      )
      url = `/${newsroomUrls['Événements'][lang]}/${slugifiedTitle}`
      break
    case 'doc':
      color = 'light-green'
      date = hit.publicationDate
      url = hit.pdf.file.url
      break
    case 'project':
      color = 'light-grey'
      date = null
      url = hit.absoluteUrlWebsite
      break
    case 'action':
      color = 'brick'
      date = null
      url = `${isFr ? '/' : '/en/'}${hit.parentPageSlug ?? ''}${hit.parentPageSlug ? '/' : ''}${slugifiedTitle}`
      break
    case 'page':
      color = 'light-grey'
      date = null

      if (hit.customType === 'Edito' || hit.customType === undefined) {
        url = `${isFr ? '/' : '/en/'}${hit.slug}`
      } else if (hit.customType === 'Blog') {
        url = `/${newsroomUrls['Blog'][lang]}/${slugifiedTitle}`
      } else {
        url = `/${newsroomUrls['Médiathèque'][lang]}/${slugifiedTitle}`
      }
      break
    case 'map':
      color = 'light-teal'
      date = null
      url = `${isFr ? '/' : '/en/'}${hit.slug}`
      break
    default:
      color = 'light-grey'
      date = null
      url = `${isFr ? '/' : '/en/'}${hit.slug}`
  }

  if (isFromPortal && hit.contentType !== 'doc') {
    url = hit.absoluteUrlPortal
  }

  /* eslint-disable */
  return (
    <>
      {hit.contentType === 'doc' || isFromPortal ? (
        <a
          href={url}
          target="_blank"
          rel="noopener noreferrer"
          className="search-hit search-hit--other"
        >
          <InnerContent
            hit={hit}
            color={color}
            date={date}
            lang={lang}
            isFromPortal={isFromPortal}
          />
        </a>
      ) : (
        <Link
          onClick={() => setSearchState()}
          to={url}
          className="search-hit search-hit--other"
        >
          <InnerContent hit={hit} color={color} date={date} lang={lang} />
        </Link>
      )}
    </>
  )
  /* eslint-enable */
}

export default HitOther
